<style lang="scss">
@import '../../assets/scss/_variables';

.illustration-radio {
    .vehicle-examples {
        margin-top: 6px;
        margin-bottom: 20px;
        padding-left: 20px;
        position: relative;

        font-size: 14px;
        font-weight: lighter;
        line-height: 1.2;
        text-align: left;
        color: $color-text-2;

        opacity: 0;
        transform: translateY(4px);
        transition:
            opacity $transition-vehicle-tooltips,
            transform $transition-vehicle-tooltips;

        .fa-info-square {
            position: absolute;
                top: 0px;
                left: 0px;

            font-size: 15px;
        }

        p {
            margin: 0;
        }

            strong {
                font-weight: normal;
            }
    }

    input:focus + label,
    label:hover {
        & + .vehicle-examples {
            opacity: 1;
            transform: none;
        }
    }

    @include media-smaller('md') {
        label + .vehicle-examples {
            padding-right: 20px;
            font-size: 12px;
            opacity: 0.7;
            transform: none;

            .fa-info-square {
                float: left;
                margin-right: 5px;
                position: static;

                font-size: 12px;
                line-height: 0.5;
            }
        }
    }
}
</style>

<template>
    <div class="illustration-radio">
        <input :id="idAttr" :name="name" :value="id" type="radio" v-model="handleModel">

        <label :for="idAttr">
            <div class="image-wrapper">
                <component :is="data.image"></component>
            </div>
            <h4 v-if="data.title" class="title">{{ data.title }}</h4>
        </label>

        <div class="vehicle-examples">
            <fa :icon="['fal', 'info-square']"></fa>
            <p>
                Example vehicles: <strong>{{ data.examples.join(', ') }}</strong>
            </p>
        </div>
    </div>
</template>

<script>
import IllustrationRadio from './IllustrationRadio.vue';

export default {
    extends: IllustrationRadio
};
</script>
